<template>
    <v-main  >
        <v-container
            class="fill-height"
            fluid
            dark
            :style="{'background-image': 'url(' + require('../../assets/bak3.jpg') + ')'}"
            style="background-size: cover"
        >
            <v-row
                align="center"
                justify="center"
            >
                <v-col
                    cols="12"
                    sm="8"
                    md="5"
                >
                    <v-col cols="12" class="text-center">
                        <img alt="Login" src="../../assets/login_img.png" style="width: 150px;">
                    </v-col>
                    <v-card 
                        class="elevation-12"
                        v-if="fetching=='fetching'"
                    >
                        <v-card-text>
                            <v-col cols="12" class="text-center">
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text
                                        class="display-1"
                                    >
                                        Validando token de seguridad
                                        <v-progress-linear
                                            indeterminate
                                            color="white"
                                            class="mb-0"
                                        ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-card-text>
                    </v-card>
                    <v-card 
                        class="elevation-12"
                        v-else-if="fetching=='error'"
                    >
                        <v-card-text>
                             <v-col cols="12" class="text-center">
                                <v-alert type="error">
                                    Lo sentimos el token enviado no le pertenece
                                </v-alert>
                             </v-col>
                        </v-card-text>
                    </v-card>
                    <v-card 
                        class="elevation-12"
                        v-else
                    >
                        <v-card-text>
                            <v-col cols="12" class="text-center pb-0">
                                <b>
                                    BIENVENIDO A LA FAMILIA INNOFARM 
                                    <br /> {{user.toUpperCase()}}
                                </b>
                                <br /> Has click en el siguiente enlace para validar tu usuario.
                            </v-col>
                        </v-card-text>
                        <v-spacer></v-spacer>
                            <v-col cols="12">
                            <v-btn 
                                color="primary" 
                                block
                                class="px-5"
                                :loading="loadingBtn"
                                @click="authUser"
                            >
                              <b> <v-icon>mdi-account-check</v-icon>  {{textValidateUser}}</b>
                            </v-btn>
                            </v-col>
                    </v-card>
                </v-col>
            </v-row>
          </v-container>
    </v-main>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'

export default {
    name:'ResetPasswordComponent',
    data : () => ({
        fetching: 'fetching',
        password:'',
        user:'',
        textValidateUser:'HAGA CLIC AQUÍ PARA VALIDAR SU USUARIO',
        rule:[
            v => !!v || 'La contraseña es requerida'
        ]
    }),
    computed:{
        ...mapState(['loadingBtn'])
    },
    methods:{

        ...mapMutations(['setLoadingBtn','setUrl', 'setUserVerificated']),

        ...mapActions(['loginAction','requestApi','alertNotification','login']),

        validateToken(token){

            this.setUrl('user-laboratorio')
            this.requestApi({
                method:'GET',
                data:{
                    token: token
                }
            })
            .then(res=>{
                console.log(res.status)
                if(res.status==200)
                    this.fetching = 'success'
                    this.user = res.data.detail
                console.log(res)
            }).catch(err=>{
                this.fetching='error'
                console.log(err)
            })
        },

        authUser(){

            this.setLoadingBtn()
            this.setUrl('user-login')

            this.requestApi({
                method:'PATCH',
                data:{
                    data:{
                        token: this.$route.params.token
                    }
                }
            }).then(res=>{

                this.textValidateUser='USUARIO VALIDADO'
                this.setLoadingBtn()
                this.setUserVerificated(true)

                setTimeout(()=>{ this.$router.push('/') },2000)                

            }).catch(err=>{
                
                console.log(err)
            })

        }

    },
    mounted(){
        
        this.validateToken(this.$route.params.token)
    }
}
</script>
